import React from 'react';
import { useIdioma } from '../../i18n';
import '../../styles/Alem.css';

const ITENS = ['busca', 'palavras', 'velocidade', 'trafegoIa', 'monitor', 'backlinks', 'equipe', 'mercado'];

/** O que a execução cruza além do rastreamento, cada bloco com o plano em que entra. */
const Alem = () => {
  const { t } = useIdioma();

  return (
    <section className="alem" id="alem" aria-labelledby="alem-titulo">
      <div className="nh-grade">
        <div className="alem-topo">
          <h2 id="alem-titulo" data-r>{t('inicio.alem.titulo')}</h2>
          <p data-r style={{ '--i': 1 }}>{t('inicio.alem.intro')}</p>
        </div>
        <div className="alem-lista">
          {ITENS.map((item, i) => (
            <article key={item} data-r style={{ '--i': i % 2 }}>
              <p className="alem-plano">{t(`inicio.alem.${item}.plano`)}</p>
              <h3>{t(`inicio.alem.${item}.titulo`)}</h3>
              <p>{t(`inicio.alem.${item}.texto`)}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Alem;
